import { FinancialStatement } from '../../../../financial-statement/models/common/FinancialStatement';
import { GeneralLedgerTemplate } from '../gl/gl.template';
import { FinancialStatementAccount } from 'src/app/domain/financial-statement/models/common/FinancialStatementAccount';
import { ExcelTemplate } from '../../../interfaces';
import * as XLSX from 'xlsx-js-style';
import { getPreparedData } from './mapping';
import { fitToColumn } from '../utils';
import { withHeaderStyling } from '../../../utils';

export class TrialBalanceTemplate implements ExcelTemplate {
  headers = [
    'Account Code',
    'Account Name',
    'Balance',
    'isManual',
  ];


  export(exportExcelData: FinancialStatement): XLSX.WorkBook {
    const book = XLSX.utils.book_new();
    const tbSheet = this.getSheet(exportExcelData.tb);
    XLSX.utils.book_append_sheet(book, tbSheet, 'Account Summary');
    if (exportExcelData.gl) {
      const glSheet = new GeneralLedgerTemplate().getSheet(exportExcelData.gl);
      XLSX.utils.book_append_sheet(book, glSheet, 'GL');
    }
    return book;
  }


  getSheet(exportExcelData: FinancialStatementAccount[]): XLSX.WorkSheet {
    const preparedData = getPreparedData(exportExcelData, this.headers);
    const sheet = {
      ...XLSX.utils.aoa_to_sheet(preparedData),
      '!cols': fitToColumn(preparedData),
    };
    return withHeaderStyling(sheet);
  }
}
